<template>
  <div id="page">
    <div class="row topCardGrid" id="cards">
      <sp-card :valor="this.contabilizacoes.total" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('Número total de dashboards')" :footerText="'Contabilizado em: ' + this.dataPTBR()">
      </sp-card>
      <sp-card :valor="this.contabilizacoes.nativos" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('Dashboards nativos')" :footerText="'Contabilizado em: ' + this.dataPTBR()">
      </sp-card>
      <sp-card :valor="this.contabilizacoes.iframes" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('Dashboards embedados (iframes)')" :footerText="'Contabilizado em: ' + this.dataPTBR()">
      </sp-card>
      <sp-card :valor="this.contabilizacoes.gerenciamento" :sufix="$t('')" classDesc="pull-right"
      :descricao="$t('Janelas de Gerenciamento')" :footerText="'Contabilizado em: ' + this.dataPTBR()">
      </sp-card>
    </div>
    <div class="row">
      <div class="flex col md12 sm12">
        <sp-360-panel  :title="'Dashboards Por Agrupamento'" :footerText="'Contabilizado em: ' + this.dataPTBR()" class="content">
          <sp360-chart id="verticalDashboardsPorPasta" type="vertical-bar" :data="chartBarDashboardPorPasta.data" class="topRow" :options="chartBarDashboardPorPasta.options" />
        </sp-360-panel>
      </div>
      <div class="flex col md7 sm7">
        <sp-360-panel id="painelDashboardsPorTipo" :title="'Dashboards Por Tipo'" :footerText="'Contabilizado em: ' + this.dataPTBR()" :footerComplementar="$t('')" v-bind:justifyVertically="true" >
          <sp360-chart :data="chartDonutTipoDashboards.data" :options="chartDonutTipoDashboards.options" type="donut" title="" class="topRow" />
        </sp-360-panel>
      </div>
      <div class="flex col md5 sm5">
        <sp360-list fit :title="'Relação de Dashboards Por Grupo'" :footerText="'Contabilizado em: ' + this.dataPTBR()" >
            <div style="padding-bottom: 2em">
              <va-input class="filter-input"
                  v-model="termoFiltro"
                  placeholder="Pesquisar"
                  removable
                  @input="pesquisa"
                  />
              <br>
            </div>
            <div class="listaCache">
                <template v-for="(item, index) in modeloDeNavegacao" class="">
                  <va-item>
                    <va-item-section>
                      <va-item-label>
                        <a class="bold">{{item.total}}</a> : {{item.titulo}}
                      </va-item-label>
                      <div v-for="(subitem, index) in item.children">
                        <va-item-label caption>
                          {{subitem.titulo}}
                        </va-item-label>
                      </div>
                    </va-item-section>
                  </va-item>
                  <va-list-separator v-if="index < modeloDeNavegacao.length-1 " />
                </template>
            </div>
          </sp360-list>
        </div>
    </div>
  </div>
</template>

<script>
import CorUtils from '@/utils/CorUtils'
import MethGlob from '@/utils/MetodosGlobais'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360List from '@/components/ui/list/VaList'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import AppSidebar from '@/components/admin/app-sidebar/AppSidebar'

export default {
  name: 'relatorio-acessos',
  components: {
    SpCard,
    Multiselect,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
  },

  data () {
    return {
      chartBarDashboardPorPasta: { data: {}, options: {} },
      termoFiltro: "",
      schemaNavigation: ['displayName', 'name', 'metaNavigation', 'children'],
      navigationModel: [],
      modeloCanonico: {},
      contabilizacoes: {total: 0, nativos: 0, iframes: 0, gerenciamento: 0},
      contabilizacoesPorPasta: [],
      modeloDeNavegacao: [],
      modeloDeNavegacaoGerado: [],
      chartDonutTipoDashboards: { chartData: {}, options: {} },
    }
  },

  created () {

    Promise.all([
      this.$store.dispatch('parametrizacao/getRotasPadrao')
      
    ]).then(respostas => {
        this.modeloCanonico = respostas[0].routes
        this.gerarSidebar()
        this.modeloDeNavegacao.forEach(item => {
          if(item.children && item.children.length > 0) {
            item.total = item.children.length
            item.children.forEach(subitem => {
              this.contabilizarSidebar(subitem)
            })
          } else {
            item.total = 1
            item.children = []
            this.contabilizarSidebar(item)
          }
        })
        this.contabilizacoes.total = this.contabilizacoes.nativos + this.contabilizacoes.iframes
        this.montarGraficoDonutTipoDashboard()
        this.montarGraficoBarrasDashPorPasta()
    })
  },

  methods: {
    pesquisa: _.debounce(function (term) {    
      let encontrados = []
      if (term && term != '' ) {
        let termo = term.trim().toUpperCase()
        encontrados = this.modeloDeNavegacaoGerado.filter(x => {
          return x.titulo.trim().toUpperCase().includes(termo) ||
          (x.children ? x.children.filter(c => c.titulo.trim().toUpperCase().includes(termo)) : []).length > 0
        })
        this.modeloDeNavegacao = encontrados
        console.log(encontrados)
      }
      else {
        this.modeloDeNavegacao = this.modeloDeNavegacaoGerado
      }

    }, 400),

    dataPTBR()
    {
      return new Date(Date.now()).toLocaleDateString("pt-BR");
    },
    gerarSidebar() {
        let navigationModel = []
        let parsedNode = {}
        this.modeloCanonico.forEach(node => {
          parsedNode = this.parseNavigationNode(node)
          if(this.existe(parsedNode)) {
            if(Array.isArray(parsedNode)) {
              navigationModel = [...navigationModel, ...parsedNode]
            } else {
              navigationModel.push(parsedNode)
            }
          }
        })
        this.modeloDeNavegacao = navigationModel
        this.modeloDeNavegacaoGerado = navigationModel
    },
    existe(el) {
      return typeof el !== 'undefined' && el != null
    },
    parseNavigationNode(node) {
        let navigation_node = null
        if((this.existe(node[this.schemaNavigation[0]]) && this.existe(node[this.schemaNavigation[1]])) || this.existe(node[this.schemaNavigation[3]])) {
            navigation_node = {}
            navigation_node['displayName'] = node[this.schemaNavigation[0]]
            navigation_node['name'] = node[this.schemaNavigation[1]]
            navigation_node['titulo'] = this.$t(node[this.schemaNavigation[0]])
            navigation_node['path'] = node['path']
            navigation_node['component'] = node['component']
            if(this.existe(node['children'])) {
                let child_nodes = []
                let parsed_child = {}
                node['children'].forEach(child => {
                    parsed_child = this.parseNavigationNode(child)
                    if(this.existe(parsed_child)) {
                        child_nodes.push(parsed_child)
                    }
                })
                navigation_node['children'] = child_nodes
            }
        }
        if(navigation_node != null && this.existe(navigation_node['children']) && 
          (!this.existe(node[this.schemaNavigation[1]]) || !this.existe(node[this.schemaNavigation[0]]))) {
            if(navigation_node['children'].length <=0) {
              return null //é um caminho do router
            } else {
              return navigation_node['children'] /*é um raiz sem display (ex.: /sp360), então retorna uma array de todos os elementos
              para serem desempacotados depois*/
            }
        }
        return navigation_node
    },
    contabilizarSidebar(item) {
      if(item.component.endsWith(".vue")) {
        if(item.component.includes('/iframe/'))
          this.contabilizacoes.iframes++
        else if(item.component.includes('/management/'))
          this.contabilizacoes.gerenciamento++
        else if(item.component.includes('/dashboard/'))
          this.contabilizacoes.nativos++
      }
    },
    montarGraficoDonutTipoDashboard () {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        label: "Distribuição dos tipos de dashboard",
        backgroundColor: _.shuffle(CorUtils.getVetorCoresPorTom('claro')),
        data: []
      }
      let cloneContab = {...this.contabilizacoes}
      delete cloneContab.total
      chartData.labels = Object.keys(cloneContab).map(x => x[0].toUpperCase() + x.substring(1))
      dataset.data = Object.values(cloneContab)

      chartData.datasets.push(dataset)

      this.chartDonutTipoDashboards.data = chartData

      this.chartDonutTipoDashboards.options = {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 40,
            bottom: 0,
          },
        },
        responsive: true,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map(data => {
                sum += data
              })
              let percentage = MethGlob.formataPercentual(value * 100 / sum) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
              return percentage
            },
            font: {
              size: 14,
              weight: 'bold',
            },
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
            offset: -5,
            rotation: 35
          },
        },
        tooltips: {
          enabled: true,
        },
      }
    },
    montarGraficoBarrasDashPorPasta() {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        backgroundColor: _.shuffle(CorUtils.getVetorCoresPorTom('claro')).shift(),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        categoryPercentage: 0.8,
        barPercentage: 1.0,
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value, ctx) => {
            let percentage = MethGlob.formataPercentual(value * 100 / (this.contabilizacoes.total + this.contabilizacoes.gerenciamento)) + '\n ' + MethGlob.thousandSeparator(parseFloat(value))
            return percentage
          },
          //anchor: 'end',
          align: 'end',
          display: 'auto',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }
      let dados = _.orderBy(this.modeloDeNavegacao, ['total'], ['desc'])
      dados.forEach(el => {
        chartData.labels.push(el.titulo)
        dataset.data.push(el.total)
      })
      chartData.datasets.push(dataset)
      this.chartBarDashboardPorPasta.data = chartData
      this.chartBarDashboardPorPasta.options = this.optionsgraficoVerticalBar()
    },
    optionsgraficoVerticalBar () {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 0,
            bottom: 20,
          },
        },
        plugins: {
          datalabels: {
            labels: {
              value: {
                font: {
                  weight: 'bold',
                },
              },
            },
            formatter: function (value, context) {
              return MethGlob.thousandSeparator(value)
            },
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
              label: function(context, value) {
                  let label = 'Dashboards: ' + context.value
                  return label;
              }
          }
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            // type: 'logarithmic',
            scaleLabel: {
              display: true,
              labelString: "Total de dashboards",
            },
            ticks: {
              maxTicksLimit: 7,
              beginAtZero: true,
              autoSkip: false,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          }],
          xAxes: [{
            id: 'BarAxis',
            position: 'left',
            gridLines: {
              display: false,
            },

            scaleLabel: {
              display: false,
              labelString: "Agrupamento",
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
              maxTicksLimit: 10,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          },
          ],
        },
      }
    },
  },
}
</script>

<style lang='scss' scoped>
    .alturaCustom {
      max-height: 40rem;
    }
    .listaCache{
      overflow-y: auto;
      overflow-wrap: break-word;
      position: relative;
      height: 25rem;
    }
    .bold{
      font-weight: bold;
      font-size: 1.2rem;
    }
    .bubble{
        height:30rem;
        width:100%;
    }
    #folhaBar{
        height:40rem
    }
    #legenddiv {
        max-height: 10rem;
    }
    #faixaEtaria{
      box-shadow: none;
      align-self: center;
    }
    ::v-deep .red{
      background-color: #40e583;
    }
    #lista{
      max-height:  35rem;
      overflow-y: scroll;
    }
    #lista::-webkit-scrollbar {
        width: 12px;
    }
    #lista::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
        border-radius: 10px;
    }
    #lista::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2);
    }
    #tabelaDeAcesso{
      padding:0;
      
    }
    .topRow{
      max-height: 30rem
    }
    .content{
       height: 100%
    }

    .content::v-deep .va-card__footer{ 
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .va-card__body{
      height: 100%
    }
  

</style>
